module.exports = __webpack_public_path__ + "img/img_people.74854987.png";